import RootState from '@/store/rootState';

export default {
    farms: [],
    knivesets: [],
    vehicles: [],
} as RootState;
